import React from 'react';
import {motion} from 'framer-motion';
import HeroSection from './components/HeroSection';
import AgitationSection from './components/AgitationSection';
import SolutionSection from './components/SolutionSection';
import SocialProofSection from './components/SocialProofSection';
import ContentSection from './components/ContentSection';
import BonusSection from './components/BonusSection';
import ValueSection from './components/ValueSection';
import PriceSection from './components/PriceSection';
import RiskReversalSection from './components/RiskReversalSection';
import FinalCTA from './components/FinalCTA';
import ExitPreventionSection from './components/ExitPreventionSection';
import DiscountTimer from './components/DiscountTimer';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 font-kanit">
      <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{duration: 0.8}}
      >
        <HeroSection />
        <AgitationSection />
        <SolutionSection />
        <SocialProofSection />
        <ContentSection />
        <BonusSection />
        <DiscountTimer />
        <ValueSection />
        <PriceSection />
        <RiskReversalSection />
        <FinalCTA />
        <ExitPreventionSection />
        <Footer />
      </motion.div>
    </div>
  );
}

export default App;